import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';
import * as aspSettings from '../../asp/aspSettings';
import { mainMapMngr } from '../../asp/MapMngr';
import { AppInjector } from '@core_n/common/inject';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import { SensorObject } from 'src/app/asp/SensorObject';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { aspMngr } from '@core_n/asp/AspMngr';
import * as msgs from './../../../../app/msg/projMsgs';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { TranslateService } from '@ngx-translate/core';
import { AnyARecord } from 'dns';

@Component({
  selector: 'sensor-snippet',
  templateUrl: './sensor-snippet.component.html',
  styleUrls: ['./../sensor-window.component.scss']
})
export class SensorSnippetComponent implements OnInit {
  @Input() sensor: SensorCoreObject;
  //@Input() DummySensors: any;

  public sliderState: boolean;
 
  constructor(protected msgBox: MsgBoxService, protected trans: TranslateService) {
  }

  ngOnInit() {
    this.sliderState = this.sensor.logiConn;
     
    this.sensor.ObjectUpdate.subscribe(x => {
      this.sliderState = this.sensor.logiConn;
    });
  }

  ngAfterViewInit() {
  }

  hookSensor() {
    aspSettings.clearSelectedIds();
    aspSettings.selectedIds.add(this.sensor.sensorID);
    this.sensor.setHooked(true);
  }

  setCenter() {
    mainMapMngr.setMapCenter(this.sensor.geometry);
  }

  openAro() {
    AppInjector.get(AroSensorService).showWindow(this.sensor as SensorObject);
  }

  async deleteSensor() {
    let confirmed = await this.msgBox.showConfirmMsgBox(this.trans.instant('ACTIONS.DELETE_SENSOR_MSG'), this.trans.instant('ACTIONS.DELETE_SENSOR_TITLE'), "Yes", "No");
    if (!confirmed)
      return;
    let sensormsg = new msgs.SetSensor();
    sensormsg.Sic = this.sensor.sic;
    sensormsg.Sac = this.sensor.sac;
    // sensormsg.isDelete = true;
    AppInjector.get(UserActionService).sendUserAction(sensormsg);
  } 

  sliderClick() {
    let sensormsg = new msgs.SetSensor();
    sensormsg.Sic = this.sensor.sic;
    sensormsg.Sac = this.sensor.sac;
    // sensormsg.LogicallyConnected = this.sliderState;

    AppInjector.get(UserActionService).sendUserAction(sensormsg);
  }
}
